module.exports = __webpack_public_path__ + "img/Close - Blue - Selected.0d8aa0db.png";